import { createContext } from 'react'

import type { AppConfig } from '@/utils/getAppConfig'

const AppConfigCtx = createContext<AppConfig | null>(null)

export default AppConfigCtx
